// src/config/firebase.ts
import { initializeApp } from 'firebase/app';
// import { getApp } from "@firebase/app";
import { getFirestore } from 'firebase/firestore';
import { 
  getAuth, 
  GoogleAuthProvider, 
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult
} from 'firebase/auth';
import { getStripePayments } from "@invertase/firestore-stripe-payments";
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
// const app = getApp();
export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);

// Initialize Stripe payments
export const payments = getStripePayments(app, {
  productsCollection: 'products',
  customersCollection: 'customers',
});

// Export Stripe-specific collection names for consistency
export const STRIPE_COLLECTIONS = {
  CUSTOMERS: 'customers',
  PRODUCTS: 'products',
  PRICES: 'prices',
  SUBSCRIPTIONS: 'subscriptions',
  PAYMENTS: 'payments',
  TAX_RATES: 'tax_rates',
  INVOICES: 'invoices',
  CHECKOUT_SESSIONS: 'checkout_sessions'
} as const;

export const googleProvider = new GoogleAuthProvider();

// Configure Google provider
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export const signInWithGoogle = async () => {
  try {
    // Try popup first
    return await signInWithPopup(auth, googleProvider);
  } catch (error: any) {
    if (error.code === 'auth/popup-blocked' || error.code === 'auth/popup-closed-by-user') {
      // If popup is blocked or closed, fall back to redirect
      return signInWithRedirect(auth, googleProvider);
    }
    throw error;
  }
};

// Handle redirect result
export const handleRedirectResult = async () => {
  try {
    const result = await getRedirectResult(auth);
    return result;
  } catch (error) {
    console.error('Error handling redirect result:', error);
    throw error;
  }
};

export default app; 
